// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'; // Import Router
import './index.css';
import App from './App';
import { AuthProviderWrapper } from './context/AuthContext'; // Import the new wrapper
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router> {/* Router is now the outermost component */}
      <AuthProviderWrapper> {/* Use the wrapper */}
        <App />
      </AuthProviderWrapper>
    </Router>
  </React.StrictMode>
);